export default __webpack_public_path__ + "static/media/spinning_light.bcc2e479.svg";